export default __webpack_public_path__ + "img/euXLEPbo.acbf824f.svg";